import { RemoteObjectStore } from '@softline/core';
import { Voucher } from '../types/voucher';

export const UploadArchiveVoucherStore = RemoteObjectStore.create<Voucher>();
